import FrictionlessLoginContainer from './FrictionlessLoginContainer';
export default FrictionlessLoginContainer;
